import { useEffect } from "react";

import { ufoEventOnboardingAutoSelectThemePreference } from "@/components/signup/utils";
import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src/index";

type AutoSelectThemeProps = {
    cloudId: string;
    product: "jira" | "confluence";
    onRequest: <T>(promise: Promise<T>) => void;
};

export const AutoSelectThemePreference = ({
    cloudId,
    product,
    onRequest
}: AutoSelectThemeProps) => {
    const stargateClient = useBxpWebStargateClient();

    useEffect(() => {
        ufoEventOnboardingAutoSelectThemePreference.start();

        ufoEventOnboardingAutoSelectThemePreference.setCustomData({
            cloudId,
            product
        });

        onRequest(
            stargateClient
                .putThemePreference({
                    cloudId,
                    product,
                    theme: "auto"
                })
                .then(() =>
                    ufoEventOnboardingAutoSelectThemePreference.success()
                )
                .catch((error: unknown) =>
                    ufoEventOnboardingAutoSelectThemePreference.failure({
                        error
                    })
                )
        );
    }, [cloudId, product, stargateClient, onRequest]);

    // This component does not render anything directly
    return null;
};
